module.exports = __webpack_public_path__ + "static/media/survey_q1_2023.7f378909.svg";